export enum ImageStyle {
  Fixed = "fixed",
  Full = "full",
  Other = "other",
}
